"use client";

import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import { motion } from "motion/react";

export default function SLLayoutGeneral({
  children,
  enableEntryAnimation = false,
}: {
  children: React.ReactNode;
  enableEntryAnimation?: boolean;
}) {
  const theme = useTheme();

  const innerSx = {
    backgroundColor: theme.palette.background.default,
    padding: "0vw",
    paddingTop: "0vw",
    position: "relative" as const,
  };

  return (
    <Box
      id="scroll-container"
      sx={{
        m: 0,
        width: { xs: "100vw", sm: "calc(100vw - 18px)" },
        position: "relative",
      }}
    >
      {enableEntryAnimation ? (
        <Box
          component={motion.div}
          sx={innerSx}
          initial={{
            height: "98vh",
            width: "100%",
          }}
          animate={{
            height: "fit-content",
            width: "unset",
          }}
          transition={{
            duration: 0.5,
            delay: 1.5,
          }}
        >
          {children}
        </Box>
      ) : (
        <Box sx={innerSx}>{children}</Box>
      )}
    </Box>
  );
}
